<template>

  <header class="flex flex-col items-center justify-center bg-center md:bg-cover bg-no-repeat bg-[url('@/assets/header.png')]">
    
    <div class="w-full flex flex-col items-center justify-center py-10">
      <img class="object-contain w-12/12" src="@/assets/logo.png" />

      <div class="flex flex-col md:flex-row w-full md:w-auto gap-2 md:gap-4 px-5 text-center mt-5">
        <router-link to="/" class="bg-gradient-to-r from-[#e25627] to-[#f1a239] hover:from-[#e94525] hover:to-[#d93b1d] text-white px-4 py-2 rounded-md transition-all duration-200" >
          <i class="pi pi-check mr-2"></i>SOY INVITADO
        </router-link>
        <router-link to="/prensa" class="bg-gradient-to-r from-[#e25627] to-[#f1a239] hover:from-[#e94525] hover:to-[#d93b1d] text-white px-4 py-2 rounded-md transition-all duration-200" >
          <i class="pi pi-check mr-2"></i>SOY PRENSA
        </router-link>
        <router-link to="/credenciales" class="bg-gradient-to-r from-[#e25627] to-[#f1a239] hover:from-[#e94525] hover:to-[#d93b1d] text-white px-4 py-2 rounded-md transition-all duration-200" >
          <i class="pi pi-check mr-2"></i>YA ME ACREDITÉ
        </router-link>
      </div>

    </div>
    
    
  </header>


</template>

<script>
import VueScrollTo from 'vue-scrollto';

export default {
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },  
}

</script>